import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/shim/with-selector';
import { useSmartLinkContext } from '@atlaskit/link-provider';
var PENDING_STATE = {
  status: 'pending'
};
export function useSmartCardState(url) {
  var _useSmartLinkContext = useSmartLinkContext(),
    store = _useSmartLinkContext.store;
  var cardState = useSyncExternalStoreWithSelector(store.subscribe, store.getState, store.getState, function (state) {
    return state[url];
  });
  return cardState !== null && cardState !== void 0 ? cardState : PENDING_STATE;
}